import React from 'react'
import { Grid } from '@material-ui/core'

import { InserirArquivo } from 'components/InserirArquivo'

import useStyles from './styles'

export const FormArquivos = (props) => {
  const { veiculoForm, processando, setProcessando } = props
  const classes = useStyles()

  return (
    <Grid className={classes.fieldGroup} alignItems="center" container justify="space-between">
      <Grid className={classes.item} item md={12} sm={12} xs={12}>
        {veiculoForm.formState.values.arquivos && (
          <InserirArquivo
            rotaUpload="/arquivo/veiculo"
            rotaLoadImagem="/arquivo/veiculo"
            setFormState={veiculoForm.setFormState}
            formState={veiculoForm.formState}
            processando={processando}
            setProcessando={setProcessando}
            tipos={['image', 'pdf']}
          />
        )}
      </Grid>
    </Grid>
  )
}
